
import {Injectable} from '@angular/core';
import {SwitchBoard} from './SwitchBoard';

@Injectable({
  providedIn: 'root'
})
export class ToastService{
  constructor(private switchBoard: SwitchBoard){}

  /** options.sentenceCase keeps the message as written. The default toast style capitalizes every word. */
  pop(type: string, message: string, data?: any, duration?: number, options?: {sentenceCase?: boolean}){
    const toastObj = {
      toastId: Math.floor(Math.random() * 1000),
      type,
      message: message || '',
      toastClass: 'toast-success',
      data,
      duration
    };
    switch (type){
      case 'success': {
        toastObj.toastClass = 'toast-success';
        break;
      }
      case 'error': {
        toastObj.toastClass = 'toast-error';
        break;
      }
      case 'info': {
        toastObj.toastClass = 'toast-info';
        break;
      }
      case 'warning': {
        toastObj.toastClass = 'toast-warning';
        break;
      }
      case 'confirm': {
        toastObj.toastClass = 'toast-confirm';
        break;
      }
    }
    if (options?.sentenceCase) {
      toastObj.toastClass += ' toast-sentence-case';
    }
    this.switchBoard.onNewToast.next(toastObj);
  }
}
